import React from 'react';
import { css } from '../styled-system/css/index';
import { Link } from 'react-router-dom';

const pageStyle = css({
  maxW: '800px',
  mt: '40px',
  mb: '40px',
  ml: 'auto',
  mr: 'auto',
  p: '0 20px',
  color: '#111827',
});

const OrderCancel = () => {
  return (
    <div className={pageStyle}>
      <h2 style={{ color: '#197bbd' }}>Payment Canceled</h2>
      <p>Your payment was canceled or failed. You can try again.</p>
      <p>
        Return to your <Link to="/cart">Cart</Link> or browse the <Link to="/products">Products</Link>.
      </p>
    </div>
  );
};

export default OrderCancel;
